import React from 'react';
import ReactDiffViewer from 'react-diff-viewer';
import { useStyletron } from 'baseui';
import { FormBuilder } from 'commons-ui';
import { Button } from 'baseui/button';
import useCreate from './useCreate';
import {
	FORM_FIELD_CONFIG,
	FORM_FIELD_CONFIG_FOR_DEV_STATUS,
	FORM_FIELD_CONFIG_FOR_DIFF,
	FORM_LAYOUT_CONFIG,
	FORM_LAYOUT_CONFIG_FOR_DEV_STATUS,
	FORM_LAYOUT_CONFIG_FOR_DIFF,
	validationSchema,
	validationSchemaForDiff,
	validationSchemaOfTournamentDevStatus
} from '../../utils/formConfig';

const CreateBanner: React.FC<{}> = () => {
	const {
		data,
		showLoader,
		handleFormSubmit,
		handleFormCancel,
		setShowLoader,
		csvDiffValue,
		handleCsvDiff,
		handleDiffDivClose,
		isDiffClose,
		handleOpenDiffForm,
		handleUploadForm,
		handleStatusForm,
		diffFormState,
		uploadFormState,
		statusFormState,
		statusLogs,
		handleTournamentStatusSubmit
	} = useCreate();
	const [css] = useStyletron();
	return (
		<div>
			<div className={css({ display: 'flex', width: '50%', justifyContent: 'center', margin: 'auto' })}>
				<div
					className={css({
						width: '300px !important',
						marginRight: '20px'
					})}>
					<Button type='button' onClick={handleOpenDiffForm}>
						Open Diff form {diffFormState && '(Active)'}
					</Button>
				</div>
				<div
					className={css({
						width: '300px !important',
						marginRight: '20px'
					})}>
					<Button type='button' onClick={handleUploadForm}>
						Open Upload form {uploadFormState && '(Active)'}
					</Button>
				</div>
				<div
					className={css({
						width: '300px !important'
					})}>
					<Button type='button' onClick={handleStatusForm}>
						Open Status form {statusFormState && '(Active)'}
					</Button>
				</div>
			</div>
			{diffFormState && (
				<FormBuilder
					data={data}
					mode='diff'
					showLoader={showLoader}
					handleFormSubmit={handleCsvDiff}
					handleFormCancel={handleDiffDivClose}
					validationSchema={validationSchemaForDiff}
					setShowLoader={setShowLoader}
					fieldConfig={FORM_FIELD_CONFIG_FOR_DIFF}
					layoutConfig={FORM_LAYOUT_CONFIG_FOR_DIFF}
					hidePopUp
					dependencies={[]}
					buttonLabels={{ submitLabel: 'Get Diff', discardLabel: 'Close Diff' }}
				/>
			)}
			{!isDiffClose && csvDiffValue.oldCsv && csvDiffValue.newCsv && (
				<div
					className={css({
						'overflow-y': 'scroll',
						'overflow-x': 'scroll',
						maxHeight: '400px',
						'word-wrap': 'break-word'
					})}>
					<ReactDiffViewer oldValue={csvDiffValue.oldCsv} newValue={csvDiffValue.newCsv} splitView={false} />
				</div>
			)}
			{uploadFormState && (
				<FormBuilder
					data={data}
					mode='create'
					showLoader={showLoader}
					handleFormSubmit={handleFormSubmit}
					handleFormCancel={handleFormCancel}
					validationSchema={validationSchema}
					setShowLoader={setShowLoader}
					fieldConfig={FORM_FIELD_CONFIG}
					layoutConfig={FORM_LAYOUT_CONFIG}
					dependencies={[]}
					buttonLabels={{ submitLabel: 'Upload Csv', discardLabel: 'Go Back' }}
				/>
			)}
			{statusFormState && (
				<FormBuilder
					data={data}
					mode='status'
					showLoader={showLoader}
					handleFormSubmit={handleTournamentStatusSubmit}
					handleFormCancel={handleFormCancel}
					validationSchema={validationSchemaOfTournamentDevStatus}
					setShowLoader={setShowLoader}
					fieldConfig={FORM_FIELD_CONFIG_FOR_DEV_STATUS}
					layoutConfig={FORM_LAYOUT_CONFIG_FOR_DEV_STATUS}
					dependencies={[]}
					hidePopUp
					buttonLabels={{ submitLabel: 'Status', discardLabel: 'Go Back' }}
				/>
			)}
			{
				// eslint-disable-next-line react/no-danger
				statusFormState && statusLogs && <div dangerouslySetInnerHTML={{ __html: statusLogs }} />
			}
		</div>
	);
};

export default CreateBanner;
